module.exports = __webpack_public_path__ + "static/media/rec0.9e4a030b.svg";